'use client';
import React from 'react';

const offerings = [
'Private luxury tours',
'Jewish heritage tours',
'Private chauffeur service',
'Airport transfers',
'Intercity transfers',
'Day trips & excursions',
'Shore excursions',
'Custom itineraries'];


const credentials = [
{ icon: '🏅', label: 'Licensed by Ministry of Tourism' },
{ icon: '⭐', label: '5-Star Rated on TripAdvisor' },
{ icon: '🌍', label: 'Serving Clients Worldwide' },
{ icon: '💬', label: 'English, French, Arabic, Hebrew' }];


export default function About() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="section-padding bg-cream">
      <div className="container-luxury">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative animate-on-scroll-left">
            {/* Main Image */}
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=700&q=85"
                alt="David, licensed professional tour guide in Morocco standing in front of traditional Moroccan architecture"
                className="w-full h-[520px] object-cover shadow-luxury"
                loading="lazy" />
              
              {/* Gold Frame Accent */}
              <div className="absolute -bottom-5 -right-5 w-full h-full border-2 border-gold -z-10" />
            </div>

            {/* Floating Badge - Years */}
            <div className="absolute -bottom-6 left-8 bg-navy text-white p-6 shadow-navy">
              <div className="font-serif text-3xl font-bold text-gold">15+</div>
              <div className="font-sans text-xs uppercase tracking-widest text-white/80 mt-1">
                Years of Excellence
              </div>
            </div>

            {/* Credential Badge */}
            <div className="absolute top-6 -right-6 bg-gold text-navy-dark p-4 shadow-gold">
              <div className="font-sans text-xs font-bold uppercase tracking-wider text-center">
                <div className="text-2xl mb-1">✓</div>
                Licensed
                <br />
                Guide
              </div>
            </div>

            {/* Credentials Strip */}
            <div className="mt-10 grid grid-cols-2 gap-3">
              {credentials.map((cred) =>
              <div key={cred.label} className="flex items-center gap-2 bg-white p-3 shadow-card">
                  <span className="text-lg">{cred.icon}</span>
                  <span className="font-sans text-xs text-navy font-semibold">{cred.label}</span>
                </div>
              )}
            </div>
          </div>

          {/* Content Side */}
          <div className="animate-on-scroll-right">
            <span className="tag-gold">About Your Guide</span>

            <h2 className="section-title mt-4 mb-2">
              Meet David
            </h2>
            <h3 className="font-serif text-2xl text-gold italic mb-4">
              Your Personal Morocco Expert
            </h3>
            <div className="gold-divider-left" />

            <p className="font-sans text-gray-700 leading-relaxed mb-4">
              Welcome! I am David, a licensed professional tour guide with a deep passion for sharing
              Morocco&apos;s extraordinary beauty, fascinating history, and rich cultural heritage through
              authentic and deeply personalized travel experiences.
            </p>

            <p className="font-sans text-gray-700 leading-relaxed mb-4">
              With over 15 years of experience guiding international visitors, I specialize in creating
              journeys that go far beyond the typical tourist trail. Travel in comfort, elegance, and
              complete privacy with tailor-made itineraries designed entirely around your interests,
              pace, and vision.
            </p>

            <p className="font-sans text-gray-700 leading-relaxed mb-6">
              I specialize in{' '}
              <span className="text-gold font-semibold">Jewish Heritage Tours</span>, guiding visitors
              through synagogues, mellahs, cemeteries, and the historic Jewish communities that have
              shaped Morocco&apos;s unique cultural identity for over 2,500 years. Whether you&apos;re
              tracing family roots or exploring history, I will make it meaningful.
            </p>

            {/* Offerings Grid */}
            <div className="grid grid-cols-2 gap-2 mb-8">
              {offerings.map((item) =>
              <div key={item} className="flex items-center gap-2 font-sans text-sm text-gray-700">
                  <div className="w-5 h-5 bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0">
                    <svg className="w-3 h-3 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  {item}
                </div>
              )}
            </div>

            {/* Quote */}
            <blockquote className="border-l-4 border-gold pl-5 py-3 mb-8 bg-white shadow-card">
              <p className="font-serif text-lg italic text-navy">
                &ldquo;Luxury is not simply the vehicle you travel in — it is the quality of every
                experience and every memory you create.&rdquo;
              </p>
              <footer className="font-sans text-sm text-gold font-semibold mt-2">— David, MoroccoJewishTours</footer>
            </blockquote>

            {/* Languages */}
            <div className="flex flex-wrap items-center gap-3 mb-8">
              <span className="font-sans text-xs text-gray-500 uppercase tracking-wider">Languages:</span>
              {['🇺🇸 English', '🇫🇷 French', '🇲🇦 Arabic', '🇮🇱 Hebrew'].map((lang) =>
              <span key={lang} className="font-sans text-xs font-semibold text-navy bg-cream px-3 py-1.5 border border-gold/20">
                  {lang}
                </span>
              )}
            </div>

            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => handleNavClick('#contact')}
                className="btn-gold">
                
                Book with David
              </button>
              <a
                href="https://wa.me/212668702424?text=Hello%20David%2C%20I%20would%20like%20to%20know%20more%20about%20your%20tours."
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline-gold">
                
                WhatsApp David
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

}